// Одна операция с принтером за раз.
//
// Соединение с принтером одно на всё приложение — и в плагине Android, и в помощнике
// Bluetooth оболочки Windows. Две операции разом (печать, «Подключиться», «Проверить
// принтер») закрывали сокет друг другу и обе заканчивались отказом — проверено на
// живом железе 2026-09-26. Очередь в веб-слое, а не в нативной части: только здесь
// видно, где у операции начало и конец (подключение, запись, отключение — одна
// операция, а не три вызова).
//
// Очередь — на владельца соединения (плагин, мост оболочки), а не на модуль: в тестах
// у каждого фейка своя очередь.
//
// У ожидания есть потолок (урок B-023: очередь без потолка замолкает навсегда).
// Каждая операция сама ограничена таймаутами, но если одна всё же не вернётся,
// следующая пойдёт после потолка, а не будет ждать вечно.

export const QUEUE_WAIT_CAP_MS = 30_000;

const queueTails = new WeakMap<object, Promise<unknown>>();

export function exclusive<T>(owner: object, operation: () => Promise<T>): Promise<T> {
  const previous = queueTails.get(owner) ?? Promise.resolve();
  let capTimer: ReturnType<typeof setTimeout> | undefined;
  const cap = new Promise<void>((resolve) => {
    capTimer = setTimeout(resolve, QUEUE_WAIT_CAP_MS);
  });
  const turn = Promise.race([previous.catch(() => undefined), cap]).finally(() => {
    clearTimeout(capTimer);
  });
  const run = turn.then(operation);
  queueTails.set(
    owner,
    run.catch(() => undefined),
  );
  return run;
}
